import { Table } from "antd"
import type { ColumnsType } from "antd/es/table"

interface HistoryTableProps<T> {
  columns: ColumnsType<T>
  rows: T[]
  loading: boolean
  pageNo: number
  perPage: number
  totalRecords: number
  onPageChange: (pageNo: number, perPage: number) => void
}

const PER_PAGE_OPTIONS = [25, 50, 100, 250]

const HistoryTable = <T extends { _id: string }>({
  columns,
  rows,
  loading,
  pageNo,
  perPage,
  totalRecords,
  onPageChange,
}: HistoryTableProps<T>) => {
  return (
    <Table
      rowKey="_id"
      columns={columns}
      dataSource={rows}
      loading={loading}
      showSorterTooltip={{ target: "sorter-icon" }}
      scroll={{ x: "max-content" }}
      pagination={{
        current: pageNo,
        pageSize: perPage,
        total: totalRecords,
        pageSizeOptions: PER_PAGE_OPTIONS,
        showSizeChanger: true,
      }}
      onChange={(pagination, _filters, _sorter, extra) => {
        if (extra.action !== "paginate") return
        onPageChange(pagination.current ?? 1, pagination.pageSize ?? perPage)
      }}
    />
  )
}

export default HistoryTable
